import { createRoot, hydrateRoot } from "react-dom/client";
import "./styles/design-tokens.css";
import "react-toastify/dist/ReactToastify.css";
import { buildAppTree } from "./AppRoot";

const container = document.getElementById("root");
const initialReleasesPayload =
  typeof window !== "undefined" ? window.__INITIAL_RELEASES_PAYLOAD || null : null;
const initialShowPayload =
  typeof window !== "undefined" ? window.__INITIAL_SHOW_PAYLOAD || null : null;
const initialMonthPayload =
  typeof window !== "undefined" ? window.__INITIAL_MONTH_PAYLOAD || null : null;
const initialArchivePayload =
  typeof window !== "undefined" ? window.__INITIAL_ARCHIVE_PAYLOAD || null : null;
const initialBestOfPayload =
  typeof window !== "undefined" ? window.__INITIAL_BEST_OF_PAYLOAD || null : null;
const initialMostRecommendedPayload =
  typeof window !== "undefined" ? window.__INITIAL_MOST_RECOMMENDED_PAYLOAD || null : null;
const initialShowsLikePayload =
  typeof window !== "undefined" ? window.__INITIAL_SHOWS_LIKE_PAYLOAD || null : null;
const initialErrorStatus =
  typeof window !== "undefined" ? window.__INITIAL_ERROR_PAGE_PAYLOAD?.status || null : null;

const appTree = buildAppTree({
  initialReleasesPayload,
  initialShowPayload,
  initialMonthPayload,
  initialArchivePayload,
  initialBestOfPayload,
  initialMostRecommendedPayload,
  initialShowsLikePayload,
  initialErrorStatus,
});

if (container.hasChildNodes()) {
  hydrateRoot(container, appTree, {
    onRecoverableError(error, errorInfo) {
      console.error("React hydration recovery", error.message, errorInfo?.componentStack || "");
    },
  });
} else {
  createRoot(container).render(appTree);
}

